import styled from 'styled-components';
import { colors } from '../colors';

interface sidebarListitemProps {
	active?: boolean;
}
const SidebarListitem = styled.div<sidebarListitemProps>`
	border-bottom: 1px solid #eaeaea;
	color: ${colors.Grey6A};
	font-weight: 500;
	padding: 15px 20px;
	font-family: 'RubikRegular';
	cursor: pointer;
	transition: 0.2s ease-in-out;
	&:hover,
	&:focus,
	&:active {
		background: ${colors.GreyF9};
		color: ${colors.BlueBase};
		a {
			color: ${colors.BlueBase};
		}
	}
	a {
		color: ${colors.Grey6A};
	}
	${({ active }) =>
		active &&
		`font-family: 'RubikMedium';
		background:${colors.GreyF9};
		color: ${colors.BlueBase};
		a{
			color: ${colors.BlueBase};
		}

	`};
`;

export default SidebarListitem;
